import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { I18nModule } from "@spartacus/core";
import { SearchBoxModule } from '../../../search-box/search-box.module';
import { NoMouseScrollModule } from "../../directives/no-mouse-scroll/no-mouse-scroll.module";
import { QuickOrderComponent } from "./quick-order/quick-order.component";


@NgModule({
  declarations: [QuickOrderComponent],
  imports: [CommonModule, SearchBoxModule, NgbModule, I18nModule, NgSelectModule, NoMouseScrollModule],
  exports: [QuickOrderComponent],
  providers: [
  ],
})
export class QuickOrderModule { }
